import bus from '../libs/bus'
export default function ({Vue}) {
    Vue.prototype.$publish = bus.publish
    Vue.prototype.$subscribe = bus.subscribe
}
